<template>
    <div class="table_container">
      <div class="table-btn" style="margin: 24px 0 12px 0">
        <el-button
          v-if="$route.query.operateType !== '查看'"
          :disabled="tableData.length >= 15"
          type="primary"
          size="small"
          @click="handleAdd()"
          >添加</el-button
        >
      </div>
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="tableData"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-class-name="cellClassName"
        @cell-click="handleCellClick"
      >
        <el-table-column
          prop="type"
          label="类别"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-if="
                editField === 'type' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.type"
              placeholder="请选择"
              filterable
              clearable
              size="mini"
              automatic-dropdown
              @visible-change="visibleChange"
              @change="confirmEdit"
            >
              <el-option label="风险" value="风险"></el-option>
              <el-option label="机会" value="机会"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.type }}
              
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="contentDescription"
          label="内容描述"
          min-width="110px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'contentDescription' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.contentDescription"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.contentDescription }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="copingStrategies"
          label="应对策略"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'copingStrategies' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.copingStrategies"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.copingStrategies }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="requirements"
          label="要求事项"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'requirements' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.requirements"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.requirements }}
            </div>
          </template>
        </el-table-column>
        
        <!-- 备注 -->
        <el-table-column
          prop="remarkk"
          label="备注"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'remarkk' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.remarkk"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.remarkk }}
            </div>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          v-if="$route.query.operateType !== '查看'"
          label="操作"
          align="center"
          width="90px"
          fixed="right"
        >
          <template slot-scope="scope">
            <!-- 删除 -->
            <el-button size="mini" type="text" @click="handleDelete(scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
</template>
  
  <script>
  import UploadImg from "@/components/uploadImgTable.vue";
  import { addOrUpdateRiskApi } from "@/api/saleTaskCollection";
  
  export default {
    components: { UploadImg },
    data() {
      return {
        tableData: [],
        editField: "", // 编辑单元格
        editIndex: -1 // 编辑行索引
      };
    },
    methods: {
      init(data) {
        this.tableData = (data||[]);
        
      },
      // 添加
      handleAdd() {
        this.tableData.push({
          type: "",
          contentDescription: "",
          copingStrategies: "",
          requirements: "",
          remarkk: "",
         
        });
      },
      // 删除
      handleDelete(index) {
        this.tableData.splice(index, 1);
      },

      // 获取单元格索引
      cellClassName({ row, column, rowIndex, columnIndex }) {
        row.index = rowIndex;
        column = { ...column, index: columnIndex };
      },
      // 点击单元格
      handleCellClick(row, column) {
        this.handleColumn(column.property, row.index ?? -1);
        this.tableData[row.index][column.property] =
          this.tableData[row.index][column.property] ?? undefined;
      },
      // 点击单元格编辑
      handleColumn(field, index) {
        if (this.$route.query.operateType === "查看") return;
        this.editField = field;
        this.editIndex = index ?? -1;
        this.$nextTick(() => {
          document.querySelector("#focusRef")?.focus();
          document.querySelector("#focusRef .el-input__inner")?.focus();
        });
      },
      // 确认编辑
      confirmEdit() {
        this.editField = "";
        this.editIndex = -1;
      },
      // el-select 显示隐藏选项框时触发
      visibleChange(visible) {
        if (!visible) {
          this.confirmEdit();
        }
      },
      // 保存
      async handleSave(params) {
        try {
          const submitData = {
            ...params,
            dataList: this.tableData
          };
          const res = await addOrUpdateRiskApi(submitData);
          if (res.status == 0) {
            this.tableData=res.data
            this.$DonMessage.success("操作成功！");
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .table_container {
    padding: 15px 18px 0 50px;
    .number_input {
      width: 100%;
      padding: 0;
      ::v-deep .el-input__inner {
        padding: 0 8px;
      }
    }
  }
  </style>
  